import PageHeader from 'components/pageHeader/PageHeader';
import { Trans, useTranslation } from 'react-i18next';
import PreviewPreArrivalFormButton from '../preview/PreviewPreArrivalFormButton';

const PreArrivalFormTabHeader = ({
  isPreviewOpen,
  setIsPreviewOpen,
}: {
  isPreviewOpen: boolean;
  setIsPreviewOpen: (isPreviewOpen: boolean) => void;
}) => {
  const { t } = useTranslation();

  return (
    <PageHeader
      title={t('pageAutomations.preArrivalForm.title')}
      subtitle={
        <Trans
          i18nKey="pageAutomations.preArrivalForm.subtitle"
          components={{
            link1: (
              <a
                aria-label="Hostfully documentation"
                href="https://help.hostfully.com/en/articles/2869492-capture-guest-information-before-their-stay-with-the-pre-arrival-form"
                target="_blank"
                rel="noreferrer"
              />
            ),
          }}
        />
      }
      buttons={
        <PreviewPreArrivalFormButton
          isPreviewOpen={isPreviewOpen}
          setIsPreviewOpen={setIsPreviewOpen}
        />
      }
      noDivider
    />
  );
};

export default PreArrivalFormTabHeader;
